import * as Yup from 'yup';

export const packageSchema = Yup.object().shape({

    name: Yup.string().required("Please enter name"),
    formIds: Yup.array()
    
})
